import axios from "axios";
import config from "../../env.json";
import { ResultData } from "../../components/DNSBinding/types";

// Redirect URI API
function addRedirectURI(payload: any, callback: any) {
  try {
    axios
      .post(config.REACT_APP_ENV_API_BASE + "/redirect/batch-add-redirect-uris", {
        redirectUris: [payload.redirectURI.trim()],
        appRegistrationId: payload.appRegistrationId.trim(),
        clientId: payload.clientId,
      })
      .then((res) => {
        callback(res.data);
      })
      .catch(() => {
        callback(null);
      });
  } catch (error) {
    callback(null);
  }
}

// Update DNS
async function updateDNS(payload: { subdomainPrefix: string; clientId: string; clientName: string }): Promise<ResultData> {
  const { data } = await axios.post(`${config.REACT_APP_ENV_API_BASE}/dns/batch-update-from-azure`, payload);
  return data;
}

// Validate DNS
async function validateDNS(payload: { subdomainPrefix: string }): Promise<ResultData> {
  const { data } = await axios.post(`${config.REACT_APP_ENV_API_BASE}/dns/batch-validate-from-azure`, payload);
  return data;
}

async function configureSuperset(payload: { id: string; name: string }): Promise<ResultData> {
  const { data } = await axios.post(`${config.REACT_APP_ENV_API_BASE}/postProvisioning/superset-provision`, payload);
  return data;

}

async function supersetReportsUrl(clientId: string, clientName: string): Promise<ResultData> {
  try {
    const response = await axios.get(`${config.REACT_APP_ENV_API_BASE}/postProvisioning/url-generate?Client_Id=${clientId}&Client_Nm=${clientName}`);
    console.log(response.data);
    return response.data;
  } catch (error: any) {
    console.error(error);
    return error;
  }

}

export { addRedirectURI, updateDNS, validateDNS, configureSuperset, supersetReportsUrl };
